export enum EventFormEventType {
  General = 0,
  Product = 2,
  Donation = 3,
  NestProduct = 4,
  Michlol = 10,
  DmeyHaver = 500,
}

const event_types = {
  1: "טיול חד יומי",
  2: "מוצר",
  3: "תרומה",
  4: "מוצר קיני",
  10: "מכלול",
  351: "מחנה",
  353: "לילה לבן",
  354: "סמינר",
  355: "טיול כולל לינה",
  356: "המסע לפולין",
  357: "אירוע שיא קיני (חג מעלות, פורימון)",
  358: "ימי עיון וימים ארציים",
  450: "פעילות קנית (ערב סרט, הפנינג)",
  451: "פעילות מחוזית יומית",
  500: "דמי חבר",
  750: "פעילות קיץ רב יומית",
  751: "סמינרי הדרכה",
  752: "השתלמויות מדריכים",
  754: "פעילות קיץ חד יומית",
  755: "סמינרי הדרכה שאינם בקיץ",
};



// WEBPACK FOOTER //
// ./src/app/admin/events-screen/event-page-models/event-form-event-type.ts